import { getApi, postApi, putApi } from "./apiService";
import { axiosInstance } from "./axiosInstance";

export const getFinanceSummary = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/finance/revenue/summary?${queryString}`);
};

export const pendingPayouts = async () => {
    return await getApi("/mp/finance/pending/payments")
}

export const completedPayouts = async () => {
    return await getApi("/mp/finance/completed/payments")
}

export const AddBankDetails = async (body) => {
    return await postApi("/mp/finance/bank/details", body)
}

export const UpdateBankDetails = async (body) => {
    return await putApi("/mp/finance/bank/details", body)
}
export const GetBankDetails = async () => {
    return await getApi("/mp/finance/bank/details")
}

export const requestWithdraw = async () => {
    return await postApi("/mp/finance/request-withdraw")
}

export const GenerateFinanceReport = async (onProgressUpdate) => {
    const url = `/mp/finance/income/reports/export`;

    const response = await axiosInstance.get(url, {
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if (onProgressUpdate) onProgressUpdate(percent);
        },
    });

    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const downloadUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = `Finance-Report-${Date.now().toString().slice(2, 9)}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
};
